var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 29.0625C22.5081 29.0625 29 22.5706 29 14.5625C29 6.55437 22.5081 0.0625 14.5 0.0625C6.49187 0.0625 0 6.55437 0 14.5625C0 22.5706 6.49187 29.0625 14.5 29.0625ZM21.6348 8.71094C22.3984 8.91016 23.0293 9.54102 23.2285 10.3379C23.627 11.7324 23.627 14.7207 23.627 14.7207C23.627 14.7207 23.627 17.6758 23.2285 19.1035C23.0293 19.9004 22.3984 20.498 21.6348 20.6973C20.207 21.0625 14.5625 21.0625 14.5625 21.0625C14.5625 21.0625 8.88477 21.0625 7.45703 20.6973C6.69336 20.498 6.0625 19.9004 5.86328 19.1035C5.46484 17.6758 5.46484 14.7207 5.46484 14.7207C5.46484 14.7207 5.46484 11.7324 5.86328 10.3379C6.0625 9.54102 6.69336 8.91016 7.45703 8.71094C8.88477 8.3125 14.5625 8.3125 14.5625 8.3125C14.5625 8.3125 20.207 8.3125 21.6348 8.71094ZM17.418 14.7207L12.7031 12.0312V17.4102L17.418 14.7207Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackYoutubeLogo);
export default __webpack_public_path__ + "static/media/black-youtube-logo.5b92de3b4b6136342de68b89d9b95f34.svg";
export { ForwardRef as ReactComponent };